<li class="btn list-item {{stateClass}}">
    <h3>{{item.alias}}</h3>
    <p>{{#if item.email}}{{item.email}}{{/if}}</p>
</li>
